/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import type { ResourceStoreContext } from '@atlassian/react-resource-router';

export const getSpaRouterContext = ({
	tenantContext,
}: ResourceStoreContext): {
	tenantContext: TenantContext;
} => ({
	tenantContext,
});
